module.exports = __webpack_public_path__ + "static/media/7.868d4e33.jpg";